// Import all blog posts here
import MindfulLivingCoachellaValley, { metadata as mindfulLivingCoachellaValleyMetadata } from '../blogs/2025-03-01-mindful-living-coachella-valley';
import EventsInCoachellaValley, { metadata as eventsInCoachellaValleyMetadata } from '../blogs/2025-04-01-events-in-coachella-valley';
import HowToFindTheRightTherapistInCoachellaValley, { metadata as howToFindTheRightTherapistInCoachellaValleyMetadata } from '../blogs/2025-04-27-how-to-find-the-right-therapist-in-coachella-valley';
import FindingStrengthAfterThePalmSpringsBombing, { metadata as findingStrengthAfterThePalmSpringsBombingMetadata } from '../blogs/2025-05-21-finding-strength-after-the-palm-springs-bombing';
import HowToBeAnAlly, { metadata as howToBeAnAllyMetadata } from '../blogs/2025-06-21-how-to-be-an-ally';
import ManagingStressDuringMidtermsAndFinals, { metadata as managingStressDuringMidtermsAndFinalsMetadata } from '../blogs/2025-08-15-managing-stress-during-midterms-and-finals';
import TheHolidayBlues, { metadata as theHolidayBluesMetadata } from '../blogs/2025-11-02-the-holiday-blues-coping-with-seasonal-sadness';
import FindingCalmInTheChaos, { metadata as findingCalmInTheChaosMetadata } from '../blogs/2025-09-15-finding-calm-in-the-chaos-dealing-with-anxiety-as-an-adolescent';
import NavigatingTheHolidaysTogether, { metadata as navigatingTheHolidaysTogetherMetadata } from '../blogs/2025-10-05-navigating-the-holidays-together-a-guide-for-couples-in-therapy';
import ManagingStressInYouthSports, { metadata as managingStressInYouthSportsMetadata } from '../blogs/2025-11-05-managing-stress-in-youth-sports-supporting-young-athletes-mental-health';
import NavigatingAlcoholAndDrugUse, { metadata as navigatingAlcoholAndDrugUseMetadata } from '../blogs/2025-11-06-navigating-alcohol-and-drug-use-during-the-holidays-a-mental-health-guide';
// Blog post configuration
export const blogConfig = [
  {
    id: '2025-03-01-mindful-living-coachella-valley',
    component: MindfulLivingCoachellaValley,
    metadata: mindfulLivingCoachellaValleyMetadata,
  },
  {
    id: '2025-04-01-events-in-coachella-valley',
    component: EventsInCoachellaValley,
    metadata: eventsInCoachellaValleyMetadata,
  },
  {
    id: '2025-04-27-how-to-find-the-right-therapist-in-coachella-valley',
    component: HowToFindTheRightTherapistInCoachellaValley,
    metadata: howToFindTheRightTherapistInCoachellaValleyMetadata,
  },
  {
    id: '2025-05-21-finding-strength-after-the-palm-springs-bombing',
    component: FindingStrengthAfterThePalmSpringsBombing,
    metadata: findingStrengthAfterThePalmSpringsBombingMetadata,
  },
  {
    id: '2025-06-21-how-to-be-an-ally',
    component: HowToBeAnAlly,
    metadata: howToBeAnAllyMetadata,
  },
  {
    id: '2025-08-15-managing-stress-during-midterms-and-finals',
    component: ManagingStressDuringMidtermsAndFinals,
    metadata: managingStressDuringMidtermsAndFinalsMetadata,
  },
  {
    id: '2025-09-15-finding-calm-in-the-chaos-dealing-with-anxiety-as-an-adolescent',
    component: FindingCalmInTheChaos,
    metadata: findingCalmInTheChaosMetadata,
  },
  {
    id: '2025-10-05-navigating-the-holidays-together-a-guide-for-couples-in-therapy',
    component: NavigatingTheHolidaysTogether,
    metadata: navigatingTheHolidaysTogetherMetadata,
  },
  {
    id: '2025-11-02-the-holiday-blues-coping-with-seasonal-sadness',
    component: TheHolidayBlues,
    metadata: theHolidayBluesMetadata,
  },
  {
    id: '2025-11-05-managing-stress-in-youth-sports-supporting-young-athletes-mental-health',
    component: ManagingStressInYouthSports,
    metadata: managingStressInYouthSportsMetadata,
  },
  {
    id: '2025-11-06-navigating-alcohol-and-drug-use-during-the-holidays-a-mental-health-guide',
    component: NavigatingAlcoholAndDrugUse,
    metadata: navigatingAlcoholAndDrugUseMetadata,
  },
  // Add new blog posts here
];

// Helper function to get blog metadata with paths
export const getBlogPosts = () => blogConfig.map((blog) => ({
  ...blog.metadata,
  path: `/blog/${blog.id}`,
}));

// Helper function to get blog routes for React Router
export const getBlogRoutes = () => blogConfig.map((blog) => ({
  path: `/blog/${blog.id}`,
  component: blog.component,
}));
